@if (isLoading) {
  <div class="loader-overlay" role="status" aria-live="polite">
    <div class="heart-wrapper" aria-hidden="true">
      <svg class="heart-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          class="heart-shape"
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4 8.24 4 9.91 5 10.54 6.36
                 11.17 5 12.76 4 14.5 4 17 4 19 6 19 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        />
        <polyline class="ekg" points="3 12 7 12 9 8 11 15 13 6 15 12 21 12" fill="none" />
      </svg>
    </div>
    <p class="loader-text mt-3 fw-semibold text-dark">Connecting to secure chat...</p>
  </div>
}

@if (!!patient && !isLoading) {
  <div class="chat-screen container py-4" style="max-width: 900px">
    <!-- Chat Container Card -->
    <div class="card booking-card chat-main-card">
      <!-- Header -->
      <div
        class="card-header booking-card__header d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center gap-3">
          <div class="chat-avatar-circle">
            {{ patient.firstName.charAt(0) }}{{ patient.lastName.charAt(0) }}
          </div>
          <div>
            <h4 class="sub-title mb-0">{{ patient.firstName }} {{ patient.lastName }}</h4>
            <small class="text-success d-flex align-items-center gap-1">
              <i class="bi bi-circle-fill" style="font-size: 0.5rem"></i> Secure Patient Line
            </small>
          </div>
        </div>

        <span
          class="badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill px-3 py-2"
        >
          Consultation Chat
        </span>
      </div>

      <!-- Messages Stream -->
      <div class="card-body p-4 chat-scroll-area">
        @if (!messages || messages.length === 0) {
          <div class="empty-state empty-state--compact my-5">
            <i class="bi bi-chat-dots fs-1 d-block mb-2 text-primary"></i>
            <h6>No messages yet</h6>
            <p class="text-muted small mb-0">
              Start the conversation with {{ patient.firstName }}.
            </p>
          </div>
        }

        <div class="d-flex flex-column gap-2">
          @for (msg of messages ?? []; track msg) {
            <div
              class="chat-bubble-row d-flex"
              [class.justify-content-end]="!isMe(msg.receiverId)"
              [class.justify-content-start]="isMe(msg.receiverId)"
            >
              <div
                class="chat-bubble"
                [class.chat-bubble-me]="!isMe(msg.receiverId)"
                [class.chat-bubble-other]="isMe(msg.receiverId)"
              >
                <div class="chat-text">{{ msg.content }}</div>
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Chat Input Footer -->
      <div class="card-footer bg-white p-3 border-top position-relative">
        <div class="input-group">
          <input
            id="chatMessage"
            class="form-control"
            placeholder="Type your consultation message..."
            [(ngModel)]="message"
            (keyup.enter)="sendMessage()"
          />

          <button class="btn btn-primary px-4" type="button" (click)="sendMessage()">
            <i class="bi bi-send-fill me-1"></i> Send
          </button>
        </div>

        @if (showEmojiPicker) {
          <div
            class="emoji-picker-container shadow-lg rounded-4 overflow-hidden position-absolute end-0 bottom-100 mb-2"
          >
            <emoji-mart (emojiSelect)="addEmoji($event)"></emoji-mart>
          </div>
        }
      </div>
    </div>
  </div>
}
